import { Dispatch, SetStateAction, useCallback } from "react";

export default function useDispatch<T>(state: T, callback: (obj: T) => void, deps: any[] = []) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(dispatchify(state, callback), [state, callback, ...deps]);
}

export function dispatchify<T>(state: T, callback: (obj: T) => void): Dispatch<SetStateAction<T>> {
  return (obj: SetStateAction<T>) => {
    if (typeof obj === "function") {
      // @ts-ignore - todo - why is it not behaving?
      callback(obj(state));
      return;
    }
    callback(obj);
  };
}
